import React from "react";
import { Helmet } from "react-helmet";

const EpisodeTwo = () => {
  const renderHeader = () => {
    return (
      <header className="container rounded-xl">
        <div className="max-w-screen-md mx-auto space-y-5">
          <h1
            className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
            title="Quiet ingenuity: 120,000 lunches and counting"
          > Message Two: A Broken Music Box
          </h1>
          <span className="block pb-1 text-base text-neutral-500 md:text-lg dark:text-neutral-400">
          Lou, currently seeking passage with her companions, thinks back on the day she met the vampire known as Benny.
          <br /><br />
          <b>Trigger Warnings:</b> violence, blood, loud sounds, alcohol, poison (mention), cannibalism (mention), emetophobia (suggested), mutation (mention), body horror
          This is a horror podcast, and so content may be unsettling or disturbing, please listen with caution.
          </span>
          <div className="w-full border-b border-neutral-300 dark:border-neutral-800"></div>
        </div>
      </header>
    );
  };

  const renderContent = () => {
    return (
      <div
        id="single-entry-content"
        className="mt-12 prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-invert"
      >
        <p>
          <i>Hi, listeners of The Moon Crown. Before I get to the episode, I want to address the June 24th
            Supreme Court decision to overturn Roe versus Wade.
            <p> This decision stripped away the right
            to have a safe and legal abortion. Restricting access to comprehensive reproductive care,
            including abortion, threatens the health of all Americans.</p>
            This decision could also lead to the loss
            of other rights. To learn more about what you can do to help, go to <a href="choice.crd.co">choice.crd.co</a>. 
            <p>I encourage you to speak up, take care, and spread the word.</p>
          </i>
        </p>
        <div className="w-full border-b border-neutral-300 dark:border-neutral-800"></div>
        <p><br /><br />
          <i>[Searching through radio channels,
          before stopping briefly on a staticky broadcast with a peppy intro song]</i>
        </p>
        <p className="text-fuchsia-600 dark:text-fuchsia-400"><i><b>Next up, there are reports of faint lines appearing in the sky.
          Scientists are still-</b></i></p>
        <p>
          <i>[Searching through radio channels continues,
          stopping briefly on a music box playing “Au Clair de La Lune”. Tuning through channels continues, then stops.]</i></p>
        <br/>
        <p><strong>LOU</strong></p>
        <p>I’ve finally found the others. They’ve been trying to get us safe passage.
          I feel like I can breathe again. I know it’s risky, broadcasting these tapes.
          It’s hard to find a station that will allow me to use their equipment.</p>
        <p><i>[CLICK with static]</i></p>
        <p>
        Easier though, than finding broadcasting equipment in the last town.
        In my case,
        I found an artisan interested in restoring these kinds of things,
        HE so graciously allowed me to come in and use it.
        </p>
        <p>I don’t think he was happy with me when I left.
          It might not have helped, when I said something about how very beautiful the equipment was,
          and that I had a mind to steal it.
          If he wasn’t around, of course.</p>
        <p>I wasn’t being serious.</p>
        <p>Even so, I doubt the things watching me there,
          hiding in the shadows, their bones clicking with every wavering movement, would let me.</p>
        <br/>
        <p>It would have been nice, if the artisan had mentioned them beforehand. If I had noticed them before sitting in a room, broadcasting under their gaze, without a thought.
          But I digress.</p>
        <br/>
        <p>When you get far away enough from smaller towns, you do find legitimate broadcasting stations.</p>
        <p>However, what makes them more difficult to use, than they are to find,
          is needing to break in and using their equipment.
          It's quite hard to do this without setting off any enchantment barriers.
          Without falling through the floor, into a pit of slick bodies, writhing, climbing ever upward.</p>

        <p>
        No matter what they say about mages, you learn a thing or two when they need a transcriber.
        Like how to avoid these folds in reality.
        </p>

        <br/>
        <p>Walking through any street here, you usually hear broadcasts from the Kingdom.
          I have also heard shop keepers tune into different channels,
          searching helplessly through the low growling and whispers. 
          The screaming, and chanting.</p>
        <br/>
        <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>
        <p>On more than one occasion,
          I’ve stopped by the bakery near our inn, only to hear the familiar tune of a broken music box,
          while picking up bread from a cashier with eyes wholly white, much too large,
          and spread too far down their face</p>
          <i>[Music stops]</i>
        <p>I do have to say, that station is my favorite.</p>

        <br /><br />
        <p>I’m going to have to sneak out tonight, when they’re asleep, just to get these recordings out to you.</p>
        <p>You see, Benny… He wants me to sit tight. If he had any say in it, he’d probably lock me in this room.
          Permanently.</p>
        <p>I don’t make the best decisions, as you can tell, if you’re hearing this.</p>
        <p>But I can tell he doesn’t trust me as much lately, and I don’t know what’s changed.
          We’re all in this.</p>
        <p>So, I haven’t told any of them that I’m not, in actuality, recording these tapes for my own sanity,
          as Chess first suggested.
          Or about the broadcasts they become.</p>
          <i>[A chair creaking]</i>
          <br />
        <p>You know, I guess they aren't so much recordings or broadcasts, as they are relays..</p>
        <p><i>Aren't they?</i></p>
        <p>Now, I’m not sure who exactly is doing this. Honestly, I’m not sure how you’ve found the inn,
          let alone my room number.</p> <i>[Shuffling paper]</i>
        <p>But it’s incredible, seeing someone use the old script, out here. And with such penmanship.</p>
        <p>I’ve only seen bits while helping with translations from the academy’s archaeologists — the Kingdom
          doesn’t even like the idea of sending Instructors on the subject to the academy.
          Some use it for sacrifice, yes, 
          but we don’t have a history of that.</p>

         <i>[Shuffling paper]</i>
         <p>But this! This is like finding an ancient artifact, specifically sent to me.</p>
         <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>
        <p>Like constellations drawing me in, pulling me in, <i className="dark:text-red-500">beckoning, <b className="text-red-700 dark:text-red-600">whispering, rising, </b></i>
        <b className="text-red-600"><u>the lines WIDENING AND CUTTING ACRO—</u></b></p>
        
        <br />
        
        <i>[Music stops as a button is clicked]</i>
        <br /><br />
        <p>I — I don’t know what that was.</p>
        <p>I don’t know... What..</p>
        <br /><br />
        <p>Well, my new penpal. Let’s not tell Benny about this?
          Why don’t we talk about... Something else? What about the day I met him?</p>
        <p>I went with Dad to get ingredients.
          Pushcarts bustled around our town’s main road. We passed displays draped in bunches of sweet-smelling sampaguita.
          I ran my fingers over the garlands, white bulbous blossoms that were strung together with silk thread.</p>
          <p>They’re beautiful of course, but lately, they reminded me of bundled hanging garlic.</p>
        <p>As we walked around, I caught sight of the apothecary.
          I’d passed it daily on the way to work,
          heard they now sell poisons you can pick up without all that paperwork.
          Imported, of course.</p>
        <p>But I’d never thought to go in.
          You see, I’d never been as committed as I was, at the start of all of this.
          But seeing what happened to Arnel, it changed something in me.</p>
        
        <p><b className="text-red-700 dark:text-red-500">It woke me up. Brought out the person I didn’t know I could be.
          Let me do the things I didn’t know I could—</b></p>
        <p>Uh... Anyways.</p>
        <p>We picked usuals for adobo, things we had just run out of at home.
          Bay leaves, vinegar, meat, we grew garlic at home, as ya' do.</p>
        <p>For a while, Arnel was going through a lot of the flesh we could buy,
          until he just stopped altogether.</p>
        <p>So, most of what we had went rancid.</p>
        <p>I’m sorry, I can’t stand talking about this. <b className="text-red-600">I can feel the rage, pure and whole, RISING—</b></p>
        <i>[A door opens, then slams]</i>
        <p>Hey.</p>
        <p>So, no luck, huh?</p>
        <i>[A frustrated sigh]</i>

        <br /><br />

        <p>I don’t know what he’s going to do if he realizes I’m telling someone about this.
        But, about the night I met him. Let me just say up front that It doesn’t make me look good.
        </p>
        <p>I stopped by the SALOON, mostly to see Benny. But also for a certain waiter.</p>
        <p>Chess left two glasses on Benny’s table. I stared at them, and Benny stared at me.</p>
        <p>“You don’t drink?”</p>
        <p>”Not with someone I don’t know.”</p>
        <p>He raised an eyebrow but sipped at his drink anyway.
          Chess set a carafe on the table, between our glasses. It swirled, milky and purple.
          Benny tapped on its neck. “What’s this?”</p>

        <p>“House — Specialty? I thought Lou ordered it?”</p>
        <p>Benny seemed doubtful, so Chess rolled his eyes went to grab the carafe. Benny caught it before he could. Chess gave me a panicked glance.</p>
        <p>“You… You did order this, didn’t you? If you've <i>changed your mind</i>, I can take it back.”</p>

        <p>“It’s fine, Chess. We’ll keep it.”</p>

        <p>When he left, Benny poured each of us a glass and drained his immediately.</p>
        <p>Miss Goliath, we’ve never spoken before, so why am I here with you, right now?”</p>
        <p>I leaned back in my chair and watched him with — satisfaction. <b className="text-red-600">“Good question.”</b></p>
        <p>He was different than I expected. I wasn’t even sure he would meet with me.</p>

        <p>Maybe he’d gone soft, over his time travelling from town to town?
          The priestesses that pass through are often uncomfortable talking about their pilgrimages outside of the continent.
          More so if the places they travel to get hit with infection and a town descends quickly into cannibalism.</p>
        <p>Even worse, occult worship, on particularly bad trips. So I've heard.
          </p>
        <p>So, I imagine it must wear on a vampire. Watching your food eat itself.</p>
        <p>Benny must have liked Gods’ Peak.
          If he didn’t, he could have killed all of us in a night.
          Maybe he was getting bored of the town, getting ready to move on.
          But what if they all were?
          I thought that, maybe, that could be the reason, for why Arnel was sick.</p>
        <p>
        “A New Gen told me you were the one I should talk to. My brother is ill. Feverish.
        He’s got bite marks and he looks drained.”</p>
          
        <p>Benny studied his empty glass. “Not. Us.” </p>
        <p>“What is that supposed to mean? How could it not be you?”</p>
        <p>He smirked. He didn't seem to have any answers.</p>

        <p>I went to grab my glass.
        Benny grabbed my wrist and I nearly spilled the drink.
        He held me there, his fingers like icicles, cutting the realization into me.</p>

      <p>Right.</p>

      <p>I've been so far in my own head, I forgot they don’t get fevers.</p>

      <p>With his other hand, Benny poured himself another glass.

      I almost didn’t notice when he let go of me. I was still trying to work out what was happening to Arnel.
      </p>
      <p>“Do you know who it could have been? Some other beast?”</p>

      <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>

      <p>A strangled expression <i className="text-red-600 dark:text-red-500">crept into his face,
        <b> as the veins in his neck turned black and his face went RED.
        It must have been <u>so hard for him to speak.</u></b></i>
        </p>

        <p>He — He choked out the words. “Is that what we are to you? Beasts?”</p>
      
        <p>“I work at the academy. It’s your classification.”</p>
        
        <p>Now, let me just correct myself. That isn't entirely true, vampires are mostly considered survivors of mutation.
          But, ah, I think about that moment, sometimes. About saying that to him.
          Actually, I’ve been thinking about what I said, in the last broadcast.
          I don’t like to think hard about what I did back then, to get <i>here. </i>
          But let’s just say that out of all of us,
          I’ve earned this life.
          And I'm starting to think I would’ve made my way to it eventually.</p>

        <p>Benny slumped in his chair and stared at his shaking hands. Blood trickled out of his ear, following his jaw. He placed his palms on the table.</p>
        
        <p>I stayed in my seat.</p>
        
        <p>I explained this to him, as I explain it to you now.</p>
        <p>There’s a process to growing garlic. Plant, trim, watch. But if you don’t cut the scapes when they form, you get flowers.</p>

        <p>Benny gave my a pained look. I glanced at his hands, the skin stretched over bones. An indent curved around his his ring finger. 
          I kept studying the curve, wondering how long he would have to wear a band for his fingers to keep that shape.</p>
        <p>
          And then I thought about Arnel. About what happens when the body rejects mutation.
          “Do you want the antidote? That’s just tea and liquor. I didn’t even bother to make an extract.
          That New Gen seemed to think you knew something. So, tell me what that could be.”
        </p>
        <p>He wheezed. “Ever hear the legends about us? What we came from?”</p>
        <p>
        I didn’t know that vampires had ever been anything else. I set a vial on the table.
        Benny went for it, almost stumbling, and he unscrewed the cap and squeezed the rubber dropper,
        letting the clear drops fall into his mouth.</p>

        <p>“I wouldn’t use so much if I were you.”</p>
        <p>“You’re <i>lucky</i> I don’t kill your kind.”</p>
        <p>“Right. So, what about that legend?”</p>
        <p>“Are you kidding me? After this, why would I tell <i>you?</i>”</p>

        <p> I nodded, folding my hands together.
        And then Benny doubled over the table, sweating, even more confused.</p>


        <p>I stood up and fished the whole bottle out of my pocket, then slid it across the table to him.
        He grabbed it. His eyes flicked back and forth, reading the label over and over again.
        As if he couldn’t understand the letters.</p>

        <p>
        I can’t blame him. The thing is, I almost couldn’t translate that bit of the old script myself.
        They really do import odd things, those apothecaries.</p>
        <p>As a testament to my character, I did not buy the arsenic that they suggested.
        But, as a peace offering, I told him what it said.

        </p>
        <p>“Ipecac.”</p>

        <p><i>[CLICK with static]</i></p>

        Now, as I’ve said, here, <i>we don’t know</i> the old script that well on this side of the river. Not even at The Academy.

        People in <u>the Kingdom</u>, they’re <i>very</i> interested in keeping the old script… <i>Alive</i>.

        Which is why you must be from the Kingdom.

        <p>So I’m not sure how,
        </p>
        <i>[Static ends]</i>
        <b><p className="text-red-900 dark:text-red-400">Or why,</p></b>
        <i><p>[Said over “Thumb” by Monophona]</p></i>
        <b><p className="text-red-700 dark:text-red-500">You’re listening to my broadcasts.</p></b>
        <b><p className="text-red-600">But still! I’m interested to hear more, to <i>read</i> more, about what you have to say!</p></b>
        <div className="w-full border-b border-neutral-300 dark:border-neutral-800"></div>
        <p><i>["Thumb" stops as the tuning through radio channels begins again,
           stopping on the same staticky broadcast from earlier]</i></p>
        <p><b className="text-fuchsia-600 dark:text-fuchsia-400">More at 11!</b></p>
        <p><i>[Tuning through channels. 
          A brief pause on a channel playing, "In the Valley of the Moon" by Henry Burr & Helen Clark.
          The tuning then continues once again, and stops on a broadcast spoken over relaxing music.]</i></p>
        <p className="text-fuchsia-600 dark:text-fuchsia-400"><b>About any side effects you may be experiencing as a result of moon-</b></p>
        <p><i>[Searching over radio channels continues, then settles. Spoken over “Thumb” by Monophona]</i></p>
        <p>The Moon Crown is a bi-weekly podcast by me, your host, Agent Molder.
        You can Tweet at, comment at, reblog, or follow TheMoonCrownPod on Tumblr, Twitter, and TikTok.</p>
        <p>You can also find more about this show, along with any music or sound effects used here, at themooncrown.netlify.app.
        That’s “A P P”.</p>
        <p>Thanks for listening.</p><p>See you next time.</p>
        <p><i>[CLICK with static]</i></p>

        <hr/>
        <h2>SFX and Music</h2>
        <ul>
          <li><a href="https://freesound.org/people/MPTSound/sounds/552482/">
            <p>"Tuning radio.wav" by MPTSound</p></a></li>
          <li>
            <a href="https://freesound.org/people/alexschmidtmeister/sounds/390518/">
              <p>"MTGSR News Cue 1704 02 Bumper.wav" by alexschmidtmeister</p>
            </a>
          </li>
          <li><a href="https://freesound.org/people/bilwiss/sounds/24724/">
            <p>"Musicbox_Au_clair_de_la_lune.WAV" by bilwiss</p></a></li>
          <li>
          <a href="https://freesound.org/people/trip_sound/sounds/190472/">
            <p>“Analog Radio” by trip_sound</p>
          </a>
          </li>
          <li>
          <a href="https://freesound.org/people/ALLANZ10D/sounds/323478/">
            <p>“Shulffing paper and book. Foley Sound” by ALLANZ10D</p>
          </a>
          </li>
          
          <li>
          <a href="https://freesound.org/people/deleted_user_7146007/sounds/383816/">
            <p>"Old Creaky Door 2" by deleted_user_7146007</p>
          </a>
          </li>
          <li>
          <a href="https://freesound.org/people/sandralaughs/sounds/519201/">
            <p>“Man sighs in frustration.m4a” by sandralaughs</p>
          </a>
          </li>
          <li>
          <a href="https://jeremymarsan.com/">
            <p>"Hello User: Bright Cheery Intro Music" by Jeremy Marsan</p>
          </a>
          </li>
          <li>
          <a href="https://freesound.org/people/joedeshon/sounds/329673/">
            <p>“Static” by joedeshon</p></a>
          </li>
          <li>
          <a href="https://soundcloud.com/monophona/thumb">
            <p>"Thumb" by Monophona</p></a>
          </li>
          <li>"In the Valley of the Moon" by Henry Burr & Helen Clark</li>
        </ul>
        
        <a href="https://twitter.com/themooncrownpod">
          <p>Don't forget, you can find the podcast on Twitter @themooncrownpod!</p>
        </a>
      </div>
    );
  };

  return (
    <div className="pt-8 nc-PageSingle lg:pt-16">
      <Helmet>
        <title>The Moon Crow, Episode One Transcript</title>
      </Helmet>
      {renderHeader()}

      <div className="container space-y-10 nc-SingleContent">
        {renderContent()}
        <div className="max-w-screen-md mx-auto border-t border-b border-neutral-100 dark:border-neutral-700"></div>
      </div>
    </div>
  );
};

export default EpisodeTwo;
